//
//
//
//
//
//
//
//
//

axios.defaults.headers = {
  Authorization: sessionStorage.getItem("Authorization")
};
import axios from "axios";
import vAside from "./Aside";
import vHeader from "./Header";
import vContent from "./Content";
export default {
  name: "manage",
  components: {
    vAside,
    vHeader,
    vContent
  },
  data() {
    return {};
  },
  mounted() {
    let timeLast = sessionStorage.getItem("time");
    let timeNow = (new Date().getTime() / 1000).toFixed(0);
    if (
      timeNow < timeLast ||
      timeNow > parseInt(timeLast) + 3600 ||
      timeLast == null ||
      sessionStorage.getItem("user") == null
    ) {
      this.$message.error("登陆已失效，请重新登陆");
      this.$router.push("/login");
    } else {
      const loading = this.$loading()
      axios.defaults.headers = {
        Authorization: sessionStorage.getItem("Authorization")
      };
      let formTmp = new FormData();
      formTmp.append("type", "manage");
      axios.post(this.$apiUrl, formTmp).then(data => {
        loading.close()
        if (data.data.success == false) {
          this.$message.error(data.data.msg);
          this.$router.push("/login");
        } else {
          this.$store.commit("changePromsg", JSON.parse(data.data.msg));
          // this.$router.push("/manage/dataQuery")
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/manage.vue